import Vue from 'vue'
import configs from '@/config'
import UnleashService from '@/services/unleash'

let resource = null

const actions = {
  getDataOpenended: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-option/list?page={page}&pageSize={pageSize}&slideId={slideId}`,
  },
  getSlideOptions: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-option/list/`,
  },
  patchSlideOptionById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}`,
  },
  createSlideOption: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/create/`,
  },
  createSpinnerWheelOptions: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/spinner-wheel/options/`,
  },
  updateSlideOption: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/slide-option/update/{slideOptionId}`,
  },
  updateSlideOptionStream: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/slide-option/update/{slideOptionId}`,
    headers: {
      'x-aha-stream': 'true',
    },
  },
  deleteSlideOption: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}`,
  },
  removeWordInTheCloud: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/remove-wordcloud/`,
  },
  getSlideOptionsBySlideId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/{slideId}/slide-options`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getDataOpenended = (page, pageSize, slideId) => {
  return resource.getDataOpenended({ page, pageSize, slideId })
}

const getSlideOptions = async (query) => {
  const res = await resource.getSlideOptions(query)
  return res.body
}

const patchSlideOptionById = async (slideOptionId, payload) => {
  const res = await resource.patchSlideOptionById({ slideOptionId }, payload)
  return res.body.slideOption
}

const createSlideOption = async (payload) => {
  const res = await resource.createSlideOption(payload)
  return res.body
}

const createSpinnerWheelOptions = async (payload) => {
  const res = await resource.createSpinnerWheelOptions(payload)
  return res.body
}

const updateSlideOption = (slideOptionId, payload) => {
  if (UnleashService.isFeatureEnabled('stream-slideoption')) {
    return resource.updateSlideOptionStream({ slideOptionId }, payload)
  }
  return resource.updateSlideOption({ slideOptionId }, payload)
}

const deleteSlideOption = async (slideOptionId, payload) => {
  const res = await resource.deleteSlideOption({ slideOptionId }, payload)
  return res.body.slide
}

const removeWordInTheCloud = async (payload) => {
  const res = await resource.removeWordInTheCloud(payload)
  return res.body
}

const getSlideOptionsBySlideId = async (slideId) => {
  const res = await resource.getSlideOptionsBySlideId({ slideId })
  return res.body
}

export default {
  initResource,
  getDataOpenended,
  patchSlideOptionById,
  createSlideOption,
  updateSlideOption,
  deleteSlideOption,
  getSlideOptions,
  createSpinnerWheelOptions,
  removeWordInTheCloud,
  getSlideOptionsBySlideId,
}
